import {makeRequest as makePublicRequest} from "./JSONApi";
export {buildPostPayload, buildAuthPostPayload, 
  buildGetPayload, buildAuthGetPayload,
  buildPutPayload, buildAuthPutPayload,
  buildDeletePayload, buildAuthDeletePayload
} from "./JSONPayload";

function getAuthToken() {
  return localStorage.getItem("access_token");
}

export function authRequest(request) {
  return request(getAuthToken()).then(({response, error}) => {
    // if (error && error.name == "ExpiredTokenException") {
    //   // Retry, but first get new token.
    //   return requestNewToken(getAuthRefreshToken())
    //     .then(({res, err}) => {
    //       return request(getAuthToken());
    //     });
    // }
    return {response, error};
  })
}

export function authRequestNoJSON(request) {
  return request(getAuthToken())
}

export function makeRequest(url, payload) {
  return makePublicRequest(url, payload)
    .then(({response, error}) => {
      return {response, error}
    })
}